import "./components/vsAcceptTerms/index.mjs";
import "./components/vsBadge/index.mjs";
import "./components/vsButton/index.mjs";
import "./components/vsCard/index.mjs";
import vn from "./components/vsCodeInput/index.mjs";
import "./components/vsForm/index.mjs";
import "./components/vsIcon/index.mjs";
import "./components/vsInput/index.mjs";
import mn from "./components/vsLogin/index.mjs";
import "./components/vsMap/index.mjs";
import "./components/vsModal/index.mjs";
import "./components/vsPreloader/index.mjs";
import "./components/vsSelectSearcher/index.mjs";
import pn from "./components/vsSidebar/index.mjs";
import "./components/vsToolbar2/index.mjs";
import hn from "./components/vsTable/index.mjs";
import "./components/vsMessage/index.mjs";
import yn from "./components/vsInbox/index.mjs";
import gn from "./components/vsBilling/index.mjs";
import "./components/vsTelInput/index.mjs";
import "./components/vsUpload/index.mjs";
import "./components/vsToast/index.mjs";
import "./components/vsSwitch/index.mjs";
import "./components/vsAvatar/index.mjs";
import "./components/vsCalendar/index.mjs";
import bn from "./components/vsTimePicker/index.mjs";
import wn from "./components/vsIndicator/index.mjs";
import "./components/vsPopover/index.mjs";
import "./components/vsDisclosure/index.mjs";
import "./components/vsSearchbar/index.mjs";
import _n from "./components/vsBanner/index.mjs";
import En from "./components/vsMenu/index.mjs";
import Sn from "./components/vsChat/index.mjs";
import Tn from "./components/vsChart/index.mjs";
import xn from "./components/vsSlider/index.mjs";
import An from "./components/vsProgressBar/index.mjs";
import On from "./components/vsItemArray/index.mjs";
import Cn from "./components/vsEditor/index.mjs";
import Mn from "./components/vsListItem2/index.mjs";
import zn from "./components/vsSignaturePad/index.mjs";
import Ln from "./components/vsInstancePicker/index.mjs";
import "./components/vsPaginator/index.mjs";
import In from "./components/vsOmniSearch/index.mjs";
import "./components/vsAddressInput/index.mjs";
import Bn from "./components/vsPlaceInput/index.mjs";
import Pn from "./components/vsColorPicker/index.mjs";
import "./components/vsOtp/index.mjs";
import Dn from "./components/vsSwiper/index.mjs";
import kn from "./components/vsTabs/index.mjs";
import Nn from "./components/vsTagsInput/index.mjs";
import $n from "./components/vsCalendarHeatmap/index.mjs";
import jn from "./components/vsRating/index.mjs";
import { v as Vn } from "./vsAvatar-BwyAoiWv.mjs";
import { r as Ba, s as Pa } from "./vsAvatar-BwyAoiWv.mjs";
import { d as W, c as Zn, v as Rn } from "./vsInput-CMeU-o-_.mjs";
import { withScopeId as Hn, pushScopeId as Fn, popScopeId as Un, withDirectives as at, createCommentVNode as k, createBlock as m, openBlock as p, withKeys as qn, createVNode as h, Transition as Ue, mergeProps as Ce, withModifiers as lt, renderSlot as Ct, Fragment as Mt, renderList as qe, vShow as st, shallowReactive as ut, ref as c, reactive as Kn, computed as R, watch as Y, onMounted as xe, onBeforeUnmount as Wn, nextTick as ge, resolveDynamicComponent as ft, toHandlers as dt, createSlots as Yn, withCtx as zt, defineComponent as Lt, onUnmounted as Ke, watchEffect as Xn, resolveComponent as Gn, toDisplayString as ct, render as It } from "vue";
import { v as Qn } from "./vsOtp-DY_5ums8.mjs";
import { v as Jn } from "./vsAddressInput-Cz04vG3-.mjs";
import { v as eo } from "./vsPaginator-C8MOD3DY.mjs";
import { v as to } from "./vsToast-C2RNE97r.mjs";
import { v as no } from "./vsSearchbar-BcFFAVue.mjs";
import { v as oo } from "./vsDisclosure-egvl1r1U.mjs";
import { v as ro } from "./vsPopover-DauLYPIx.mjs";
import { v as io } from "./vsCalendar-Cj3ZLH8g.mjs";
import { v as ao } from "./vsSwitch-CXPXuCZn.mjs";
import { v as lo } from "./vsUpload-CDWjMLUp.mjs";
import { v as so } from "./vsTelInput-DDMjHdHU.mjs";
import { v as uo } from "./vsMessage-C1OmdEp5.mjs";
import { v as fo } from "./vsToolbar-C_u0GSp3.mjs";
import { v as co } from "./vsSelectSearcher-DAKP21EE.mjs";
import { v as vo } from "./vsPreloader-DE9TMol9.mjs";
import { v as mo } from "./vsModal-BLdVBDEF.mjs";
import { v as po } from "./vsMap-BIzM7EoO.mjs";
import { v as ho } from "./vsIcon-Cyr63bPF.mjs";
import { v as yo } from "./vsForm-DvT4HwEm.mjs";
import { v as go } from "./vsCard-CgHEnE92.mjs";
import { v as bo } from "./vsButton-BlFL21k0.mjs";
import { v as wo } from "./vsBadge-DmDe4A9x.mjs";
import { v as _o } from "./vsAcceptTerms-C0K9HxDf.mjs";
/**
  * vee-validate v4.15.0
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
const be = {
  en: /^[A-Z\s]*$/i,
  cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
  da: /^[A-ZÆØÅ\s]*$/i,
  de: /^[A-ZÄÖÜß\s]*$/i,
  es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
  fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
  it: /^[A-Z\xC0-\xFF\s]*$/i,
  lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
  nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
  hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
  pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
  pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
  ru: /^[А-ЯЁ\s]*$/i,
  kz: /^[А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA\s]*$/i,
  sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
  sr: /^[A-ZČĆŽŠĐ\s]*$/i,
  sv: /^[A-ZÅÄÖ\s]*$/i,
  tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
  uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
  az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i,
  ug: /^[A-Zچۋېرتيۇڭوپھسداەىقكلزشغۈبنمژفگخجۆئ\s]*$/i
}, we = {
  en: /^[0-9A-Z]*$/i,
  cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
  da: /^[0-9A-ZÆØÅ]$/i,
  de: /^[0-9A-ZÄÖÜß]*$/i,
  es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
  fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
  it: /^[0-9A-Z\xC0-\xFF]*$/i,
  lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
  hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
  nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
  pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
  pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
  ru: /^[0-9А-ЯЁ]*$/i,
  kz: /^[0-9А-ЯЁ\u04D8\u04B0\u0406\u04A2\u0492\u04AE\u049A\u04E8\u04BA]*$/i,
  sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
  sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
  sv: /^[0-9A-ZÅÄÖ]*$/i,
  tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
  uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
  az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i,
  ug: /^[0-9A-Zچۋېرتيۇڭوپھسداەىقكلزشغۈبنمژفگخجۆئ]*$/i
}, Bt = (t) => {
  if (t)
    return Array.isArray(t) ? t[0] : t.locale;
};
function Ye(t, e) {
  return Array.isArray(t) ? t[0] : t[e];
}
function ae(t) {
  return !!(t == null || t === "" || Array.isArray(t) && t.length === 0);
}
const Pt = (t, e) => {
  if (ae(t))
    return !0;
  const n = Bt(e);
  if (Array.isArray(t))
    return t.every((r) => Pt(r, { locale: n }));
  const o = String(t);
  return n ? (we[n] || we.en).test(o) : Object.keys(we).some((r) => we[r].test(o));
}, Dt = (t, e) => {
  if (ae(t))
    return !0;
  const n = Bt(e);
  if (Array.isArray(t))
    return t.every((r) => Dt(r, { locale: n }));
  const o = String(t);
  return n ? (be[n] || be.en).test(o) : Object.keys(be).some((r) => be[r].test(o));
}, vt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Eo = (t) => ae(t) ? !0 : Array.isArray(t) ? t.every((e) => vt.test(String(e))) : vt.test(String(t)), So = (t, e) => {
  const n = Ye(e, "other");
  return t === n;
}, To = (t, e) => {
  if (ae(t))
    return !0;
  const n = Ye(e, "length");
  return typeof t == "number" && (t = String(t)), t.length || (t = Array.from(t)), t.length === Number(n);
}, kt = (t, e) => {
  if (ae(t))
    return !0;
  const n = Ye(e, "length");
  return Array.isArray(t) ? t.every((o) => kt(o, { length: n })) : [...String(t)].length >= Number(n);
}, xo = /^[٠١٢٣٤٥٦٧٨٩]+$/, Ao = /^[0-9]+$/, Oo = (t) => {
  if (ae(t))
    return !0;
  const e = (n) => {
    const o = String(n);
    return Ao.test(o) || xo.test(o);
  };
  return Array.isArray(t) ? t.every(e) : e(t);
};
function Co(t) {
  return t == null;
}
function Mo(t) {
  return Array.isArray(t) && t.length === 0;
}
const zo = (t) => Co(t) || Mo(t) || t === !1 ? !1 : !!String(t).trim().length;
/**
  * vee-validate v4.15.0
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
function mt(t) {
  return typeof t == "function";
}
function Lo(t) {
  return typeof t == "object" && t !== null;
}
function Io(t) {
  return t == null ? t === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(t);
}
function pt(t) {
  if (!Lo(t) || Io(t) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(t) === null)
    return !0;
  let e = t;
  for (; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
function Nt(t, e) {
  return Object.keys(e).forEach((n) => {
    if (pt(e[n]) && pt(t[n])) {
      t[n] || (t[n] = {}), Nt(t[n], e[n]);
      return;
    }
    t[n] = e[n];
  }), t;
}
function ht(t, e, n) {
  const { prefix: o, suffix: r } = n, i = Bo(o, r);
  return t.replace(i, function(a, l, u) {
    if (!l || !e.params)
      return u in e ? e[u] : e.params && u in e.params ? e.params[u] : `${o}${u}${r}`;
    if (!Array.isArray(e.params))
      return u in e.params ? e.params[u] : `${o}${u}${r}`;
    const f = Number(l.replace(":", ""));
    return f in e.params ? e.params[f] : `${l}${o}${u}${r}`;
  });
}
function yt(t) {
  return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Bo(t, e) {
  const n = yt(t), o = yt(e);
  return new RegExp(`([0-9]:)?${n}((?:(?!${o}).)+)${o}`, "g");
}
class Po {
  constructor(e, n, o = { prefix: "{", suffix: "}" }) {
    this.container = {}, this.locale = e, this.interpolateOptions = o, this.merge(n);
  }
  resolve(e, n) {
    let o = this.format(this.locale, e, n);
    return !o && this.fallbackLocale && this.fallbackLocale !== this.locale && (o = this.format(this.fallbackLocale, e, n)), o || this.getDefaultMessage(this.locale, e);
  }
  getDefaultMessage(e, n) {
    const { label: o, name: r } = n;
    return `${this.resolveLabel(e, r, o)} is not valid`;
  }
  getLocaleDefault(e, n) {
    var o, r, i, a, l;
    return ((i = (r = (o = this.container[e]) === null || o === void 0 ? void 0 : o.fields) === null || r === void 0 ? void 0 : r[n]) === null || i === void 0 ? void 0 : i._default) || ((l = (a = this.container[e]) === null || a === void 0 ? void 0 : a.messages) === null || l === void 0 ? void 0 : l._default);
  }
  resolveLabel(e, n, o) {
    var r, i, a, l;
    return o ? ((i = (r = this.container[e]) === null || r === void 0 ? void 0 : r.names) === null || i === void 0 ? void 0 : i[o]) || o : ((l = (a = this.container[e]) === null || a === void 0 ? void 0 : a.names) === null || l === void 0 ? void 0 : l[n]) || n;
  }
  format(e, n, o) {
    var r, i, a, l, u;
    let f;
    const { rule: _, form: E, label: A, name: b } = n, w = this.resolveLabel(e, b, A);
    return _ ? (f = ((a = (i = (r = this.container[e]) === null || r === void 0 ? void 0 : r.fields) === null || i === void 0 ? void 0 : i[b]) === null || a === void 0 ? void 0 : a[_.name]) || ((u = (l = this.container[e]) === null || l === void 0 ? void 0 : l.messages) === null || u === void 0 ? void 0 : u[_.name]), f || (f = this.getLocaleDefault(e, b) || ""), mt(f) ? f(n) : ht(f, Object.assign(Object.assign({}, E), { field: w, params: _.params }), o ?? this.interpolateOptions)) : (f = this.getLocaleDefault(e, b) || "", mt(f) ? f(n) : ht(f, Object.assign(Object.assign({}, E), { field: w }), o ?? this.interpolateOptions));
  }
  merge(e) {
    Nt(this.container, e);
  }
}
const je = new Po("en", {});
function Do(t, e, n) {
  const o = (r) => je.resolve(r, n);
  return typeof t == "string" ? (je.locale = t, o) : (je.merge(t), o);
}
const ko = "en", No = { _default: "The {field} is not valid", alpha: "The {field} field may only contain alphabetic characters", alpha_num: "The {field} field may only contain alpha-numeric characters", alpha_dash: "The {field} field may contain alpha-numeric characters as well as dashes and underscores", alpha_spaces: "The {field} field may only contain alphabetic characters as well as spaces", between: "The {field} field must be between 0:{min} and 1:{max}", confirmed: "The {field} field confirmation does not match", digits: "The {field} field must be numeric and exactly contain 0:{length} digits", dimensions: "The {field} field must be 0:{width} pixels by 1:{height} pixels", email: "The {field} field must be a valid email", not_one_of: "The {field} field is not a valid value", ext: "The {field} field is not a valid file", image: "The {field} field must be an image", integer: "The {field} field must be an integer", length: "The {field} field must be 0:{length} long", max_value: "The {field} field must be 0:{max} or less", max: "The {field} field may not be greater than 0:{length} characters", mimes: "The {field} field must have a valid file type", min_value: "The {field} field must be 0:{min} or more", min: "The {field} field must be at least 0:{length} characters", numeric: "The {field} field may only contain numeric characters", one_of: "The {field} field is not a valid value", regex: "The {field} field format is invalid", required_if: "The {field} field is required", required: "The {field} field is required", size: "The {field} field size must be less than 0:{size}KB", url: "The {field} field is not a valid URL" }, $o = {
  code: ko,
  messages: No
}, jo = "es", Vo = { alpha: "El campo {field} solo debe contener letras", alpha_dash: "El campo {field} solo debe contener letras, números y guiones", alpha_num: "El campo {field} solo debe contener letras y números", alpha_spaces: "El campo {field} solo debe contener letras y espacios", between: "El campo {field} debe estar entre 0:{min} y 1:{max}", confirmed: "El campo {field} no coincide", digits: "El campo {field} debe ser numérico y contener exactamente 0:{length} dígitos", dimensions: "El campo {field} debe ser de 0:{width} píxeles por 1:{height} píxeles", email: "El campo {field} debe ser un correo electrónico válido", not_one_of: "El campo {field} debe ser un valor válido", ext: "El campo {field} debe ser un archivo válido", image: "El campo {field} debe ser una imagen", one_of: "El campo {field} debe ser un valor válido", integer: "El campo {field} debe ser un entero", length: "El largo del campo {field} debe ser 0:{length}", max: "El campo {field} no debe ser mayor a 0:{length} caracteres", max_value: "El campo {field} debe de ser 0:{max} o menor", mimes: "El campo {field} debe ser un tipo de archivo válido", min: "El campo {field} debe tener al menos 0:{length} caracteres", min_value: "El campo {field} debe ser 0:{min} o superior", numeric: "El campo {field} debe contener solo caracteres numéricos", regex: "El formato del campo {field} no es válido", required: "El campo {field} es obligatorio", required_if: "El campo {field} es obligatorio", size: "El campo {field} debe ser menor a 0:{size}KB" }, Zo = {
  code: jo,
  messages: Vo
}, Aa = () => {
  W("required", zo), W("is", So), W("email", Eo), W("min", kt), W("numeric", Oo), W("alpha_spaces", Dt), W("alpha_num", Pt), W("length", To), Zn({
    generateMessage: Do({
      es: Zo,
      en: $o
    })
  });
};
function fe(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? fe = function(e) {
    return typeof e;
  } : fe = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, fe(t);
}
function gt(t, e, n, o, r, i, a) {
  try {
    var l = t[i](a), u = l.value;
  } catch (f) {
    n(f);
    return;
  }
  l.done ? e(u) : Promise.resolve(u).then(o, r);
}
function Ro(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(o, r) {
      var i = t.apply(e, n);
      function a(u) {
        gt(i, o, r, a, l, "next", u);
      }
      function l(u) {
        gt(i, o, r, a, l, "throw", u);
      }
      a(void 0);
    });
  };
}
function Ho(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fo(t, e) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
  }
}
function Uo(t, e, n) {
  return e && Fo(t.prototype, e), t;
}
function re(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function bt(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function M(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? bt(Object(n), !0).forEach(function(o) {
      re(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : bt(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function oe(t) {
  return qo(t) || Ko(t) || Wo(t) || Yo();
}
function qo(t) {
  if (Array.isArray(t)) return We(t);
}
function Ko(t) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(t)) return Array.from(t);
}
function Wo(t, e) {
  if (t) {
    if (typeof t == "string") return We(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return We(t, e);
  }
}
function We(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++) o[n] = t[n];
  return o;
}
function Yo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Xo = 'button:not([disabled]), select:not([disabled]), a[href]:not([disabled]), area[href]:not([disabled]), [contentEditable=""]:not([disabled]), [contentEditable="true"]:not([disabled]), [contentEditable="TRUE"]:not([disabled]), textarea:not([disabled]), iframe:not([disabled]), input:not([disabled]), summary:not([disabled]), [tabindex]:not([tabindex="-1"])', Go = function(e) {
  return e.key === "Tab" || e.keyCode === 9;
}, Qo = function(e, n) {
  return oe(e.querySelectorAll(n) || []);
}, Jo = function(e) {
  return Qo(e, Xo);
}, wt = function(e) {
  return e == document.activeElement;
}, er = function() {
  return !document.activeElement;
}, tr = /* @__PURE__ */ function() {
  function t() {
    Ho(this, t), this.root = null, this.elements = [], this.onKeyDown = this.onKeyDown.bind(this), this.enable = this.enable.bind(this), this.disable = this.disable.bind(this), this.firstElement = this.firstElement.bind(this), this.lastElement = this.lastElement.bind(this);
  }
  return Uo(t, [{
    key: "lastElement",
    value: function() {
      return this.elements[this.elements.length - 1] || null;
    }
  }, {
    key: "firstElement",
    value: function() {
      return this.elements[0] || null;
    }
  }, {
    key: "onKeyDown",
    value: function(n) {
      if (Go(n)) {
        if (n.shiftKey) {
          wt(this.firstElement()) && (this.lastElement().focus(), n.preventDefault());
          return;
        }
        if (er() || wt(this.lastElement())) {
          this.firstElement().focus(), n.preventDefault();
          return;
        }
      }
    }
  }, {
    key: "enabled",
    value: function() {
      return !!this.root;
    }
  }, {
    key: "enable",
    value: function(n) {
      n && (this.root = n, this.elements = Jo(this.root), this.root.addEventListener("keydown", this.onKeyDown));
    }
  }, {
    key: "disable",
    value: function() {
      this.root.removeEventListener("keydown", this.onKeyDown), this.root = null;
    }
  }]), t;
}(), nr = function(e, n, o) {
  var r = e.style[n];
  return e.style[n] = o, function() {
    e.style[n] = r;
  };
}, _t = function(e) {
  var n = e.targetTouches ? e.targetTouches[0] : e, o = n.clientX, r = n.clientY;
  return {
    x: o,
    y: r
  };
}, or = function(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}, _e = function(e, n, o) {
  return typeof e != "number" && (e = Math.min(n, o) || n), typeof o != "number" && (o = Math.max(n, e)), Math.min(Math.max(n, e), o);
}, Et = function(e) {
  return e && Number(e.replace(/px$/, "")) || 0;
}, rr = function(e, n, o) {
  if (o === "") return !0;
  var r = oe(n.querySelectorAll(o));
  return r.includes(e.target);
}, Me = {
  down: {
    pc: "mousedown",
    m: "touchstart"
  },
  move: {
    pc: "mousemove",
    m: "touchmove"
  },
  up: {
    pc: "mouseup",
    m: "touchend"
  }
}, Ee = function(e, n, o) {
  n && n.addEventListener(Me[e].pc, o), n && n.addEventListener(Me[e].m, o, {
    passive: !1
  });
}, Se = function(e, n, o) {
  n && n.removeEventListener(Me[e].pc, o), n && n.removeEventListener(Me[e].m, o);
}, Xe = !1;
if (typeof window < "u") {
  var St = {
    get passive() {
      Xe = !0;
    }
  };
  window.addEventListener("testPassive", null, St), window.removeEventListener("testPassive", null, St);
}
var $t = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), G = [], ze = !1, Ae = 0, jt = -1, de, ce, ir = function(e) {
  if (!e || e.nodeType !== Node.ELEMENT_NODE) return !1;
  var n = window.getComputedStyle(e);
  return ["auto", "scroll"].includes(n.overflowY) && e.scrollHeight > e.clientHeight;
}, ar = function(e, n) {
  return !(e.scrollTop === 0 && n < 0 || e.scrollTop + e.clientHeight + n >= e.scrollHeight && n > 0);
}, lr = function(e) {
  for (var n = []; e; ) {
    if (n.push(e), e.classList.contains("vfm")) return n;
    e = e.parentElement;
  }
  return n;
}, sr = function(e, n) {
  var o = !1, r = lr(e);
  return r.forEach(function(i) {
    ir(i) && ar(i, n) && (o = !0);
  }), o;
}, Vt = function(e) {
  return G.some(function() {
    return sr(e, -Ae);
  });
}, Le = function(e) {
  var n = e || window.event;
  return Vt(n.target) || n.touches.length > 1 ? !0 : (n.preventDefault && n.preventDefault(), !1);
}, ur = function(e) {
  if (ce === void 0) {
    var n = !!e && e.reserveScrollBarGap === !0, o = window.innerWidth - document.documentElement.clientWidth;
    if (n && o > 0) {
      var r = parseInt(getComputedStyle(document.body).getPropertyValue("padding-right"), 10);
      ce = document.body.style.paddingRight, document.body.style.paddingRight = "".concat(r + o, "px");
    }
  }
  de === void 0 && (de = document.body.style.overflow, document.body.style.overflow = "hidden");
}, fr = function() {
  ce !== void 0 && (document.body.style.paddingRight = ce, ce = void 0), de !== void 0 && (document.body.style.overflow = de, de = void 0);
}, dr = function(e) {
  return e ? e.scrollHeight - e.scrollTop <= e.clientHeight : !1;
}, cr = function(e, n) {
  return Ae = e.targetTouches[0].clientY - jt, Vt(e.target) ? !1 : n && n.scrollTop === 0 && Ae > 0 || dr(n) && Ae < 0 ? Le(e) : (e.stopPropagation(), !0);
}, vr = function(e, n) {
  if (!e) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!G.some(function(r) {
    return r.targetElement === e;
  })) {
    var o = {
      targetElement: e,
      options: n || {}
    };
    G = [].concat(oe(G), [o]), $t ? (e.ontouchstart = function(r) {
      r.targetTouches.length === 1 && (jt = r.targetTouches[0].clientY);
    }, e.ontouchmove = function(r) {
      r.targetTouches.length === 1 && cr(r, e);
    }, ze || (document.addEventListener("touchmove", Le, Xe ? {
      passive: !1
    } : void 0), ze = !0)) : ur(n);
  }
}, Ve = function(e) {
  if (!e) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  G = G.filter(function(n) {
    return n.targetElement !== e;
  }), $t ? (e.ontouchstart = null, e.ontouchmove = null, ze && G.length === 0 && (document.removeEventListener("touchmove", Le, Xe ? {
    passive: !1
  } : void 0), ze = !1)) : G.length || fr();
}, Te = function() {
}, V = {
  Enter: "enter",
  Entering: "entering",
  Leave: "leave",
  Leaving: "leavng"
}, mr = {
  t: "ns-resize",
  tr: "nesw-resize",
  r: "ew-resize",
  br: "nwse-resize",
  b: "ns-resize",
  bl: "nesw-resize",
  l: "ew-resize",
  tl: "nwse-resize"
}, Be = {
  props: {
    name: {
      type: String,
      default: null
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    ssr: {
      type: Boolean,
      default: !0
    },
    classes: {
      type: [String, Object, Array],
      default: ""
    },
    overlayClass: {
      type: [String, Object, Array],
      default: ""
    },
    contentClass: {
      type: [String, Object, Array],
      default: ""
    },
    styles: {
      type: [Object, Array],
      default: function() {
        return {};
      }
    },
    overlayStyle: {
      type: [Object, Array],
      default: function() {
        return {};
      }
    },
    contentStyle: {
      type: [Object, Array],
      default: function() {
        return {};
      }
    },
    lockScroll: {
      type: Boolean,
      default: !0
    },
    hideOverlay: {
      type: Boolean,
      default: !1
    },
    clickToClose: {
      type: Boolean,
      default: !0
    },
    escToClose: {
      type: Boolean,
      default: !1
    },
    preventClick: {
      type: Boolean,
      default: !1
    },
    attach: {
      type: null,
      default: !1,
      validator: function(e) {
        var n = fe(e);
        return n === "boolean" || n === "string" ? !0 : e.nodeType === Node.ELEMENT_NODE;
      }
    },
    transition: {
      type: [String, Object],
      default: "vfm"
    },
    overlayTransition: {
      type: [String, Object],
      default: "vfm"
    },
    keepOverlay: {
      type: Boolean,
      default: !1
    },
    zIndexAuto: {
      type: Boolean,
      default: !0
    },
    zIndexBase: {
      type: [String, Number],
      default: 1e3
    },
    zIndex: {
      type: [Boolean, String, Number],
      default: !1
    },
    focusRetain: {
      type: Boolean,
      default: !0
    },
    focusTrap: {
      type: Boolean,
      default: !1
    },
    fitParent: {
      type: Boolean,
      default: !0
    },
    drag: {
      type: Boolean,
      default: !1
    },
    dragSelector: {
      type: String,
      default: ""
    },
    keepChangedStyle: {
      type: Boolean,
      default: !1
    },
    resize: {
      type: Boolean,
      default: !1
    },
    resizeDirections: {
      type: Array,
      default: function() {
        return ["t", "tr", "r", "br", "b", "bl", "l", "tl"];
      },
      validator: function(e) {
        return ["t", "tr", "r", "br", "b", "bl", "l", "tl"].filter(function(n) {
          return e.indexOf(n) !== -1;
        }).length === e.length;
      }
    },
    minWidth: {
      type: Number,
      default: 0
    },
    minHeight: {
      type: Number,
      default: 0
    },
    maxWidth: {
      type: Number,
      default: 1 / 0
    },
    maxHeight: {
      type: Number,
      default: 1 / 0
    }
  },
  emits: ["update:modelValue", "click-outside", "before-open", "opened", "before-close", "closed", "_before-open", "_opened", "_closed", "drag:start", "drag:move", "drag:end", "resize:start", "resize:move", "resize:end"],
  setup: function(e, n) {
    var o = n.emit, r = Symbol("vfm"), i = c(null), a = c(null), l = c(null), u = c(null), f = c(null), _ = c(null), E = c(null), A = new tr(), b = c(!1), w = Kn({
      modal: !1,
      overlay: !1,
      resize: !1
    }), H = c(null), Q = c(null), J = c(!1), x = c({}), S = c({}), y = c(null), z = c(null), N = Te, U = Te, ve = R(function() {
      return typeof e.overlayTransition == "string" ? {
        name: e.overlayTransition
      } : M({}, e.overlayTransition);
    }), me = R(function() {
      return typeof e.transition == "string" ? {
        name: e.transition
      } : M({}, e.transition);
    }), Wt = R(function() {
      return (e.hideOverlay || H.value === V.Leave) && Q.value === V.Leave;
    }), De = R(function() {
      return e.zIndex === !1 ? e.zIndexAuto ? +e.zIndexBase + 2 * (E.value || 0) : !1 : e.zIndex;
    }), Yt = R(function() {
      return M({}, De.value !== !1 && {
        zIndex: De.value
      });
    }), Xt = R(function() {
      var s = [S.value];
      return Array.isArray(e.contentStyle) ? s.push.apply(s, oe(e.contentStyle)) : s.push(e.contentStyle), s;
    });
    Y(function() {
      return e.modelValue;
    }, function(s) {
      if (J.value) {
        J.value = !1;
        return;
      }
      if (pe(), !s) {
        if (tt("before-close", !0)) {
          U("hide");
          return;
        }
        Je();
      }
    }), Y(function() {
      return e.lockScroll;
    }, Ne), Y(function() {
      return e.hideOverlay;
    }, function(s) {
      e.modelValue && !s && (w.overlay = !0);
    }), Y(function() {
      return e.attach;
    }, pe), Y(Wt, function(s) {
      s && (b.value = !1, a.value.style.display = "none");
    }, {
      flush: "post"
    }), Y(function() {
      return e.drag;
    }, function(s) {
      b.value && (s ? nt() : ot());
    }), Y(function() {
      return e.resize;
    }, function(s) {
      b.value && (s ? rt() : it());
    }), Y(function() {
      return e.keepChangedStyle;
    }, function(s) {
      s || (S.value = {});
    }), xe(function() {
      e.api.modals.push(ke()), pe();
    }), Wn(function() {
      var s;
      Je(), e.lockScroll && a.value && Ve(a.value), i == null || (s = i.value) === null || s === void 0 || s.remove();
      var d = e.api.modals.findIndex(function(v) {
        return v.uid === r;
      });
      e.api.modals.splice(d, 1);
    });
    function ke() {
      return {
        uid: r,
        props: e,
        emit: o,
        vfmContainer: a,
        vfmContent: l,
        vfmResize: u,
        vfmOverlayTransition: f,
        vfmTransition: _,
        getAttachElement: et,
        modalStackIndex: E,
        visibility: w,
        handleLockScroll: Ne,
        $focusTrap: A,
        toggle: dn,
        params: x
      };
    }
    function pe() {
      if (e.modelValue) {
        if (o("_before-open", le({
          type: "_before-open"
        })), tt("before-open", !1)) {
          U("show");
          return;
        }
        var s = et();
        if (s || e.attach === !1) {
          if (e.attach !== !1)
            if (i.value)
              s.appendChild(i.value);
            else {
              b.value = !0, ge(function() {
                pe();
              });
              return;
            }
          var d = e.api.openedModals.findIndex(function(v) {
            return v.uid === r;
          });
          d !== -1 && e.api.openedModals.splice(d, 1), e.api.openedModals.push(ke()), E.value = e.api.openedModals.length - 1, Ne(), e.api.openedModals.filter(function(v) {
            return v.uid !== r;
          }).forEach(function(v, O) {
            v.getAttachElement() === s && (v.modalStackIndex.value = O, !v.props.keepOverlay && (v.visibility.overlay = !1));
          }), b.value = !0, Gt();
        } else s !== !1 && console.warn("Unable to locate target ".concat(e.attach));
      }
    }
    function Je() {
      var s = e.api.openedModals.findIndex(function(v) {
        return v.uid === r;
      });
      if (s !== -1 && e.api.openedModals.splice(s, 1), e.api.openedModals.length > 0) {
        var d = e.api.openedModals[e.api.openedModals.length - 1];
        d.props.focusTrap && d.$focusTrap.firstElement().focus(), (d.props.focusRetain || d.props.focusTrap) && d.vfmContainer.value.focus(), !d.props.hideOverlay && (d.visibility.overlay = !0);
      }
      e.drag && ot(), e.resize && it(), y.value = null, Qt();
    }
    function Ne() {
      e.modelValue && ge(function() {
        e.lockScroll ? vr(a.value, {
          reserveScrollBarGap: !0
        }) : Ve(a.value);
      });
    }
    function et() {
      var s;
      return e.attach === !1 ? s = !1 : typeof e.attach == "string" ? window ? s = window.document.querySelector(e.attach) : s = !1 : s = e.attach, s;
    }
    function Gt() {
      w.overlay = !0, w.modal = !0;
    }
    function Qt() {
      w.overlay = !1, w.modal = !1;
    }
    function Jt() {
      H.value = V.Entering;
    }
    function en() {
      H.value = V.Enter;
    }
    function tn() {
      H.value = V.Leaving;
    }
    function nn() {
      H.value = V.Leave;
    }
    function on() {
      Q.value = V.Entering;
    }
    function rn() {
      Q.value = V.Enter, (e.focusRetain || e.focusTrap) && a.value.focus(), e.focusTrap && A.enable(a.value), e.drag && nt(), e.resize && rt(), o("_opened"), o("opened", le({
        type: "opened"
      })), N("show");
    }
    function an() {
      Q.value = V.Leaving, A.enabled() && A.disable();
    }
    function ln() {
      Q.value = V.Leave, E.value = null, e.lockScroll && Ve(a.value), e.keepChangedStyle || (S.value = {});
      var s = !1, d = le({
        type: "closed",
        stop: function() {
          s = !0;
        }
      });
      o("_closed"), o("closed", d), N("hide"), !s && (x.value = {});
    }
    function sn(s) {
      z.value = s == null ? void 0 : s.target;
    }
    function un() {
      z.value === a.value && y.value !== "resize:move" && (o("click-outside", le({
        type: "click-outside"
      })), e.clickToClose && o("update:modelValue", !1));
    }
    function fn() {
      b.value && e.escToClose && o("update:modelValue", !1);
    }
    function le() {
      var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return M({
        ref: ke()
      }, s);
    }
    function tt(s, d) {
      var v = !1, O = le({
        type: s,
        stop: function() {
          v = !0;
        }
      });
      return o(s, O), v ? (J.value = !0, ge(function() {
        o("update:modelValue", d);
      }), !0) : !1;
    }
    function $e(s, d, v) {
      y.value = "".concat(d, ":").concat(v), o(y.value, s);
    }
    function dn(s, d) {
      var v = arguments;
      return new Promise(function(O, C) {
        N = function(T) {
          O(T), N = Te;
        }, U = function(T) {
          C(T), U = Te;
        };
        var ee = typeof s == "boolean" ? s : !e.modelValue;
        ee && v.length === 2 && (x.value = d), o("update:modelValue", ee);
      });
    }
    function he(s) {
      s.stopPropagation();
      var d = "resize", v = "drag", O = s.target.getAttribute("direction"), C;
      if (O)
        C = d;
      else if (rr(s, l.value, e.dragSelector))
        C = v;
      else
        return;
      $e(s, C, "start");
      var ee = _t(s), L = a.value.getBoundingClientRect(), T = l.value.getBoundingClientRect(), q = window.getComputedStyle(l.value).position === "absolute", $ = {
        top: Et(S.value.top),
        left: Et(S.value.left)
      }, g = function() {
        if (e.fitParent) {
          var K = {
            absolute: function() {
              return {
                minTop: 0,
                minLeft: 0,
                maxTop: L.height - T.height,
                maxLeft: L.width - T.width
              };
            },
            relative: function() {
              return {
                minTop: $.top + L.top - T.top,
                minLeft: $.left + L.left - T.left,
                maxTop: $.top + L.bottom - T.bottom,
                maxLeft: $.left + L.right - T.right
              };
            }
          };
          return q ? K.absolute() : K.relative();
        } else
          return {};
      }(), I = C === d && nr(document.body, "cursor", mr[O]), P = function(D) {
        D.stopPropagation(), $e(D, C, "move");
        var se = _t(D), B = {
          x: se.x - ee.x,
          y: se.y - ee.y
        };
        C === d && (B = cn(O, B, L, T, q));
        var F, te;
        q ? (F = T.top - L.top + B.y, te = T.left - L.left + B.x) : (F = $.top + B.y, te = $.left + B.x), C === v && e.fitParent && (F = _e(g.minTop, F, g.maxTop), te = _e(g.minLeft, te, g.maxLeft));
        var ye = M(M(M({
          position: "relative",
          top: F + "px",
          left: te + "px",
          margin: "unset",
          touchAction: "none"
        }, q && {
          position: "absolute",
          transform: "unset",
          width: T.width + "px",
          height: T.height + "px"
        }), B.width && {
          width: B.width + "px"
        }), B.height && {
          height: B.height + "px"
        });
        S.value = M(M({}, S.value), ye);
      }, j = function K(D) {
        D.stopPropagation(), C === d && I && I(), setTimeout(function() {
          $e(D, C, "end");
        }), Se("move", document, P), Se("up", document, K);
      };
      Ee("move", document, P), Ee("up", document, j);
    }
    function nt() {
      Ee("down", l.value, he), S.value.touchAction = "none";
    }
    function ot() {
      Se("down", l.value, he);
    }
    function rt() {
      w.resize = !0, ge(function() {
        Ee("down", u.value, he);
      });
    }
    function it() {
      Se("down", u.value, he), w.resize = !1;
    }
    function cn(s, d, v, O, C) {
      var ee = function(g) {
        var I, P = d[g.axis];
        P = e.fitParent ? _e(g.min, P, g.max) : P;
        var j = _e(g.minEdge, g.getEdge(P), g.maxEdge);
        return P = g.getOffsetAxis(j, C), I = {}, re(I, g.edgeName, j), re(I, g.axis, P), I;
      }, L = function(g, I, P, j) {
        var K = O[I], D = v[g] - O[g], se = or(I);
        return {
          axis: P,
          edgeName: I,
          min: j ? D : -K,
          max: j ? K : D,
          minEdge: e["min".concat(se)],
          maxEdge: e["max".concat(se)],
          getEdge: function(F) {
            return O[I] - F * (j ? 1 : -1);
          },
          getOffsetAxis: function(F, te) {
            var ye = O[I] - F;
            return te ? j ? ye : 0 : (j ? 1 : -1) * ye / 2;
          }
        };
      }, T = {
        t: ["top", "height", "y", !0],
        b: ["bottom", "height", "y", !1],
        l: ["left", "width", "x", !0],
        r: ["right", "width", "x", !1]
      }, q = {
        x: 0,
        y: 0
      };
      return s.split("").forEach(function($) {
        var g = L.apply(void 0, oe(T[$]));
        q = M(M({}, q), ee(g));
      }), q;
    }
    return {
      root: i,
      vfmContainer: a,
      vfmContent: l,
      vfmResize: u,
      vfmOverlayTransition: f,
      vfmTransition: _,
      computedOverlayTransition: ve,
      computedTransition: me,
      visible: b,
      visibility: w,
      params: x,
      calculateZIndex: De,
      bindStyle: Yt,
      bindContentStyle: Xt,
      beforeOverlayEnter: Jt,
      afterOverlayEnter: en,
      beforeOverlayLeave: tn,
      afterOverlayLeave: nn,
      beforeModalEnter: on,
      afterModalEnter: rn,
      beforeModalLeave: an,
      afterModalLeave: ln,
      onMousedown: sn,
      onMouseupContainer: un,
      onEsc: fn
    };
  }
}, Ze = Hn("data-v-2836fdb5");
Fn("data-v-2836fdb5");
var pr = {
  key: 0,
  ref: "vfmResize",
  class: "vfm__resize vfm--absolute vfm--inset vfm--prevent-none vfm--select-none vfm--touch-none"
};
Un();
var hr = Ze(function(t, e, n, o, r, i) {
  return n.ssr || o.visible ? at((p(), m("div", {
    key: 0,
    ref: "root",
    style: o.bindStyle,
    class: ["vfm vfm--inset", [n.attach === !1 ? "vfm--fixed" : "vfm--absolute", {
      "vfm--prevent-none": n.preventClick
    }]],
    onKeydown: e[4] || (e[4] = qn(function() {
      return o.onEsc && o.onEsc.apply(o, arguments);
    }, ["esc"]))
  }, [h(Ue, Ce(o.computedOverlayTransition, {
    onBeforeEnter: o.beforeOverlayEnter,
    onAfterEnter: o.afterOverlayEnter,
    onBeforeLeave: o.beforeOverlayLeave,
    onAfterLeave: o.afterOverlayLeave
  }), {
    default: Ze(function() {
      return [!n.hideOverlay && o.visibility.overlay ? (p(), m("div", {
        key: 0,
        class: ["vfm__overlay vfm--overlay vfm--absolute vfm--inset", n.overlayClass],
        style: n.overlayStyle
      }, null, 6)) : k("v-if", !0)];
    }),
    _: 1
  }, 16, ["onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"]), h(Ue, Ce(o.computedTransition, {
    onBeforeEnter: o.beforeModalEnter,
    onAfterEnter: o.afterModalEnter,
    onBeforeLeave: o.beforeModalLeave,
    onAfterLeave: o.afterModalLeave
  }), {
    default: Ze(function() {
      return [at(h("div", {
        ref: "vfmContainer",
        class: ["vfm__container vfm--absolute vfm--inset vfm--outline-none", n.classes],
        style: n.styles,
        "aria-expanded": o.visibility.modal.toString(),
        role: "dialog",
        "aria-modal": "true",
        tabindex: "-1",
        onMouseup: e[2] || (e[2] = lt(function() {
          return o.onMouseupContainer && o.onMouseupContainer.apply(o, arguments);
        }, ["self"])),
        onMousedown: e[3] || (e[3] = lt(function() {
          return o.onMousedown && o.onMousedown.apply(o, arguments);
        }, ["self"]))
      }, [h("div", {
        ref: "vfmContent",
        class: ["vfm__content", [n.contentClass, {
          "vfm--prevent-auto": n.preventClick
        }]],
        style: o.bindContentStyle,
        onMousedown: e[1] || (e[1] = function(a) {
          return o.onMousedown(null);
        })
      }, [Ct(t.$slots, "default", {
        params: o.params,
        close: function() {
          return t.$emit("update:modelValue", !1);
        }
      }), o.visibility.resize && o.visibility.modal ? (p(), m("div", pr, [(p(!0), m(Mt, null, qe(n.resizeDirections, function(a) {
        return p(), m("div", {
          key: a,
          direction: a,
          class: ["vfm--resize-".concat(a), "vfm--absolute vfm--prevent-auto"]
        }, null, 10, ["direction"]);
      }), 128))], 512)) : k("v-if", !0)], 38)], 46, ["aria-expanded"]), [[st, o.visibility.modal]])];
    }),
    _: 3
  }, 16, ["onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])], 38)), [[st, !n.ssr || o.visible]]) : k("v-if", !0);
});
function yr(t, e) {
  e === void 0 && (e = {});
  var n = e.insertAt;
  if (!(typeof document > "u")) {
    var o = document.head || document.getElementsByTagName("head")[0], r = document.createElement("style");
    r.type = "text/css", n === "top" && o.firstChild ? o.insertBefore(r, o.firstChild) : o.appendChild(r), r.styleSheet ? r.styleSheet.cssText = t : r.appendChild(document.createTextNode(t));
  }
}
var gr = `
.vfm--fixed[data-v-2836fdb5] {
  position: fixed;
}
.vfm--absolute[data-v-2836fdb5] {
  position: absolute;
}
.vfm--inset[data-v-2836fdb5] {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.vfm--overlay[data-v-2836fdb5] {
  background-color: rgba(0, 0, 0, 0.5);
}
.vfm--prevent-none[data-v-2836fdb5] {
  pointer-events: none;
}
.vfm--prevent-auto[data-v-2836fdb5] {
  pointer-events: auto;
}
.vfm--outline-none[data-v-2836fdb5]:focus {
  outline: none;
}
.vfm-enter-active[data-v-2836fdb5],
.vfm-leave-active[data-v-2836fdb5] {
  transition: opacity 0.2s;
}
.vfm-enter-from[data-v-2836fdb5],
.vfm-leave-to[data-v-2836fdb5] {
  opacity: 0;
}
.vfm--touch-none[data-v-2836fdb5] {
  touch-action: none;
}
.vfm--select-none[data-v-2836fdb5] {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}
.vfm--resize-tr[data-v-2836fdb5],
.vfm--resize-br[data-v-2836fdb5],
.vfm--resize-bl[data-v-2836fdb5],
.vfm--resize-tl[data-v-2836fdb5] {
  width: 12px;
  height: 12px;
  z-index: 10;
}
.vfm--resize-t[data-v-2836fdb5] {
  top: -6px;
  left: 0;
  width: 100%;
  height: 12px;
  cursor: ns-resize;
}
.vfm--resize-tr[data-v-2836fdb5] {
  top: -6px;
  right: -6px;
  cursor: nesw-resize;
}
.vfm--resize-r[data-v-2836fdb5] {
  top: 0;
  right: -6px;
  width: 12px;
  height: 100%;
  cursor: ew-resize;
}
.vfm--resize-br[data-v-2836fdb5] {
  bottom: -6px;
  right: -6px;
  cursor: nwse-resize;
}
.vfm--resize-b[data-v-2836fdb5] {
  bottom: -6px;
  left: 0;
  width: 100%;
  height: 12px;
  cursor: ns-resize;
}
.vfm--resize-bl[data-v-2836fdb5] {
  bottom: -6px;
  left: -6px;
  cursor: nesw-resize;
}
.vfm--resize-l[data-v-2836fdb5] {
  top: 0;
  left: -6px;
  width: 12px;
  height: 100%;
  cursor: ew-resize;
}
.vfm--resize-tl[data-v-2836fdb5] {
  top: -6px;
  left: -6px;
  cursor: nwse-resize;
}
`;
yr(gr);
Be.render = hr;
Be.__scopeId = "data-v-2836fdb5";
Be.__file = "lib/VueFinalModal.vue";
var Ge = {
  props: {},
  methods: {
    slice: function(e) {
      this.api.dynamicModals.splice(e, 1);
    },
    beforeOpen: function(e, n, o) {
      var r = this;
      return Ro(function* () {
        e.ref.params.value = n.params, yield r.$nextTick(), yield r.$nextTick(), n.value || (r.slice(o), n.reject("show"));
      })();
    },
    isString: function(e) {
      return typeof e == "string";
    }
  }
}, br = {
  class: "modals-container"
};
function wr(t, e, n, o, r, i) {
  return p(), m("div", br, [(p(!0), m(Mt, null, qe(t.api.dynamicModals, function(a, l) {
    return p(), m(ft(a.component), Ce({
      key: a.id
    }, a.bind, {
      modelValue: a.value,
      "onUpdate:modelValue": function(f) {
        return a.value = f;
      }
    }, dt(a.on), {
      on_closed: function(f) {
        return i.slice(l);
      },
      on_beforeOpen: function(f) {
        return i.beforeOpen(f, a);
      },
      on_opened: a.opened
    }), Yn({
      _: 2
    }, [qe(a.slots, function(u, f) {
      return {
        name: f,
        fn: zt(function() {
          return [k(" eslint-disable vue/no-v-html "), i.isString(u) ? (p(), m("div", {
            key: 0,
            innerHTML: u
          }, null, 8, ["innerHTML"])) : (p(), m(ft(u.component), Ce({
            key: 1
          }, u.bind, dt(u.on || {})), null, 16))];
        })
      };
    })]), 1040, ["modelValue", "onUpdate:modelValue", "on_closed", "on_beforeOpen", "on_opened"]);
  }), 128))]);
}
Ge.render = wr;
Ge.__file = "lib/ModalsContainer.vue";
function _r() {
  var t = null;
  return {
    show: function(n) {
      for (var o = this, r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
        i[a - 1] = arguments[a];
      switch (fe(n)) {
        case "string":
          return this.toggle.apply(this, [n, !0].concat(i));
        case "object":
          return Promise.allSettled([new Promise(function(l, u) {
            var f = {
              value: !0,
              id: Symbol("dynamicModal"),
              component: t,
              bind: {},
              slots: {},
              on: {},
              params: i[0],
              reject: u,
              opened: function() {
                l("show");
              }
            };
            o.dynamicModals.push(ut(Object.assign(f, n)));
          })]);
      }
    },
    hide: function() {
      for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
        o[r] = arguments[r];
      return this.toggle(o, !1);
    },
    hideAll: function() {
      return this.hide.apply(this, oe(this.openedModals.map(function(n) {
        return n.props.name;
      })));
    },
    toggle: function(n) {
      for (var o = arguments.length, r = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
        r[i - 1] = arguments[i];
      var a = Array.isArray(n) ? this.get.apply(this, oe(n)) : this.get(n);
      return Promise.allSettled(a.map(function(l) {
        return l.toggle.apply(l, r);
      }));
    },
    get: function() {
      for (var n = arguments.length, o = new Array(n), r = 0; r < n; r++)
        o[r] = arguments[r];
      return this.modals.filter(function(i) {
        return o.includes(i.props.name);
      });
    },
    dynamicModals: ut([]),
    openedModals: [],
    modals: [],
    _setDefaultModal: function(n) {
      t = n;
    }
  };
}
function Zt(t, e) {
  var n = M(M({}, t), {}, {
    props: M({}, t.props)
  });
  return Object.assign(n.props, {
    api: {
      type: Object,
      default: function() {
        return e;
      }
    }
  }), n;
}
function Er(t) {
  var e = Zt(Be, t);
  return t._setDefaultModal(e), e;
}
function Sr(t) {
  return Zt(Ge, t);
}
var Tt = 0, Rt = "$vfm", Ht = "VueFinalModal", Ft = "ModalsContainer", Ut = function() {
  var e, n = _r();
  return e = {}, re(e, Rt, n), re(e, Ht, Er(n)), re(e, Ft, Sr(n)), e;
}, Pe = Ut(), Oa = Pe.$vfm;
Pe.VueFinalModal;
Pe.ModalsContainer;
var qt = function(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = Tt === 0 ? Pe : Ut(), r = o.$vfm, i = o.VueFinalModal, a = o.ModalsContainer;
  Tt += 1;
  var l = n.key || Rt, u = n.componentName || Ht, f = n.dynamicContainerName || Ft;
  Object.defineProperty(e.config.globalProperties, l, {
    get: function() {
      return r;
    }
  }), e.provide(l, r), e.component(u, i), e.component(f, a);
}, Tr = function(e) {
  return {
    install: function(o, r) {
      var i = Object.assign({}, e, r);
      qt(o, i);
    }
  };
};
Tr.install = qt;
var xr = Object.defineProperty, Ar = Object.defineProperties, Or = Object.getOwnPropertyDescriptors, xt = Object.getOwnPropertySymbols, Cr = Object.prototype.hasOwnProperty, Mr = Object.prototype.propertyIsEnumerable, At = (t, e, n) => e in t ? xr(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Z = (t, e) => {
  for (var n in e || (e = {})) Cr.call(e, n) && At(t, n, e[n]);
  if (xt) for (var n of xt(e)) Mr.call(e, n) && At(t, n, e[n]);
  return t;
}, Qe = (t, e) => Ar(t, Or(e));
const ue = { type: "default", timeout: 5e3, showCloseButton: !0, position: "top-right", transition: "bounce", hideProgressBar: !1, swipeClose: !0 };
var ne, X;
(X = ne || (ne = {}))[X.TITLE_ONLY = 0] = "TITLE_ONLY", X[X.TITLE_DESCRIPTION = 1] = "TITLE_DESCRIPTION", X[X.COMPONENT = 2] = "COMPONENT", X[X.VNODE = 3] = "VNODE";
const zr = { "top-left": { bounce: "mosha__bounceInLeft", zoom: "mosha__zoomIn", slide: "mosha__slideInLeft" }, "top-right": { bounce: "mosha__bounceInRight", zoom: "mosha__zoomIn", slide: "mosha__slideInRight" }, "top-center": { bounce: "mosha__bounceInDown", zoom: "mosha__zoomIn", slide: "mosha__slideInDown" }, "bottom-center": { bounce: "mosha__bounceInUp", zoom: "mosha__zoomIn", slide: "mosha__slideInUp" }, "bottom-right": { bounce: "mosha__bounceInRight", zoom: "mosha__zoomIn", slide: "mosha__slideInRight" }, "bottom-left": { bounce: "mosha__bounceInLeft", zoom: "mosha__zoomIn", slide: "mosha__slideInLeft" } }, Ca = (t, e) => h(t, e), Ot = (t, e = 300) => {
  let n;
  return (...o) => {
    n && (clearTimeout(n), n = void 0), n = setTimeout(() => t(...o), e);
  };
}, Lr = (t, e, n) => {
  const o = c(), r = c(void 0), i = c(), a = (f) => f instanceof MouseEvent, l = (f) => {
    n !== !1 && o.value && (a(f) ? r.value = o.value.clientX - f.clientX : r.value = o.value.touches[0].clientX - f.touches[0].clientX, i.value = Qe(Z({}, i.value), { transition: "none" }), t.endsWith("left") ? i.value.left = -r.value + "px !important" : t.endsWith("right") ? i.value.right = `${r.value}px !important` : r.value > 0 ? i.value.left = -r.value + "px !important" : i.value.right = `${r.value}px !important`, Math.abs(r.value) > 200 && e());
  }, u = (f) => {
    n !== !1 && (o.value && (o.value = void 0), r.value && (r.value = void 0), removeEventListener(f, l));
  };
  return Ke(() => {
    n !== !1 && (u("mousemove"), u("touchmove"));
  }), { swipedDiff: r, swipeStart: o, swipeStyle: i, swipeHandler: l, startSwipeHandler: (f) => {
    if (n === !1) return;
    o.value = f;
    const _ = a(f) ? "mousemove" : "touchmove", E = a(f) ? "mouseup" : "touchend";
    addEventListener(_, l), addEventListener(E, () => ((A) => {
      const b = { transition: "left .3s ease-out", left: 0 }, w = { transition: "right .3s ease-out", right: 0 }, H = { transition: "all .3s ease-out", left: 0, right: 0 };
      t.endsWith("left") ? i.value = Z(Z({}, i.value), b) : t.endsWith("right") ? i.value = Z(Z({}, i.value), w) : i.value = Z(Z({}, i.value), H), o.value = void 0, r.value = void 0, removeEventListener(A, l);
    })(_));
  }, cleanUpMove: u };
};
var Kt = Lt({ props: { type: { type: String, default: "default" } } });
const Ir = { class: "mosha__icon" }, Br = { key: 0, xmlns: "http://www.w3.org/2000/svg", height: "32px", viewBox: "0 0 24 24", width: "32px", fill: "#ffffff" }, Pr = h("path", { d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z" }, null, -1), Dr = { key: 1, xmlns: "http://www.w3.org/2000/svg", height: "32px", viewBox: "0 0 24 24", width: "32px", fill: "#ffffff" }, kr = h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 11c-.55 0-1-.45-1-1V8c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z" }, null, -1), Nr = { key: 2, xmlns: "http://www.w3.org/2000/svg", height: "32px", viewBox: "0 0 24 24", width: "32px", fill: "#ffffff" }, $r = h("path", { d: "M0 0h24v24H0V0z", fill: "none" }, null, -1), jr = h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM9.29 16.29L5.7 12.7c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L10 14.17l6.88-6.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-7.59 7.59c-.38.39-1.02.39-1.41 0z" }, null, -1), Vr = { key: 3, xmlns: "http://www.w3.org/2000/svg", height: "32px", viewBox: "0 0 24 24", width: "32px", fill: "#616161" }, Zr = h("path", { d: "M0 0h24v24H0z", fill: "none" }, null, -1), Rr = h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" }, null, -1), Hr = { key: 4, xmlns: "http://www.w3.org/2000/svg", height: "32px", viewBox: "0 0 24 24", width: "32px", fill: "#ffffff" }, Fr = h("path", { d: "M0 0h24v24H0z", fill: "none" }, null, -1), Ur = h("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" }, null, -1);
Kt.render = function(t, e, n, o, r, i) {
  return p(), m("span", Ir, [t.type === "warning" ? (p(), m("svg", Br, [Pr])) : t.type === "danger" ? (p(), m("svg", Dr, [kr])) : t.type === "success" ? (p(), m("svg", Nr, [$r, jr])) : t.type === "default" ? (p(), m("svg", Vr, [Zr, Rr])) : (p(), m("svg", Hr, [Fr, Ur]))]);
};
var Oe = Lt({ name: "MToast", components: { MIcon: Kt }, props: { visible: Boolean, text: { type: String, default: "" }, description: { type: String, default: "" }, toastBackgroundColor: { type: String, default: "" }, type: { type: String, default: "default" }, onClose: { type: Function, default: () => null }, onCloseHandler: { type: Function, required: !0 }, offset: { type: Number, required: !0 }, id: { type: Number, required: !0 }, timeout: { type: Number, default: 5e3 }, position: { type: String, required: !0 }, showCloseButton: { type: Boolean, default: !0 }, swipeClose: { type: Boolean, default: !0 }, hideProgressBar: { type: Boolean, default: !1 }, showIcon: { type: Boolean, default: !1 }, transition: { type: String, default: "bounce" } }, setup(t, e) {
  const n = c(), { width: o } = (() => {
    const x = c(-1), S = c(-1), y = (z) => {
      z !== null && z.currentTarget !== null && (x.value = z.currentTarget.innerWidth, S.value = z.currentTarget.innerHeight);
    };
    return xe(() => {
      window.innerWidth > 0 && (x.value = window.innerWidth, S.value = window.innerHeight), window.addEventListener("resize", Ot(y));
    }), Ke(() => {
      window.removeEventListener("resize", Ot(y));
    }), { width: x, height: S };
  })(), { swipedDiff: r, startSwipeHandler: i, swipeStyle: a, cleanUpMove: l } = Lr(t.position, t.onCloseHandler, t.swipeClose), { transitionType: u } = (f = t.position, _ = t.transition, E = r, { transitionType: R(() => E.value > 200 ? "mosha__fadeOutLeft" : E.value < -200 ? "mosha__fadeOutRight" : zr[f][_]) });
  var f, _, E;
  const { start: A, stop: b, progress: w } = ((x, S) => {
    const y = c(), z = c(0), N = c(S), U = c(), ve = c(100), me = () => {
      clearInterval(U.value), clearTimeout(y.value);
    };
    return xe(() => {
    }), Ke(() => {
      me();
    }), { start: () => {
      z.value = Date.now(), clearTimeout(y.value), U.value = setInterval(() => {
        ve.value--;
      }, S / 100 - 5), y.value = setTimeout(x, N.value);
    }, stop: () => {
      clearInterval(U.value), clearTimeout(y.value), N.value -= Date.now() - z.value;
    }, clear: me, progress: ve };
  })(() => {
    t.onCloseHandler();
  }, t.timeout), H = R(() => e.slots.default), Q = R(() => /<\/?[a-z][\s\S]*>/i.test(t.description)), J = () => {
    t.timeout > 0 && A();
  };
  return Xn(() => {
    const { customStyle: x } = ((S, y, z) => {
      const N = R(() => {
        switch (S) {
          case "top-left":
            return { left: "0", top: `${y}px` };
          case "bottom-left":
            return { left: "0", bottom: `${y}px` };
          case "bottom-right":
            return { right: "0", bottom: `${y}px` };
          case "top-center":
            return { top: `${y}px`, left: "0", right: "0", marginRight: "auto", marginLeft: "auto" };
          case "bottom-center":
            return { bottom: `${y}px`, left: "0", right: "0", marginRight: "auto", marginLeft: "auto" };
          default:
            return { right: "0", top: `${y}px` };
        }
      });
      return z.length > 0 && (N.value.backgroundColor = z), { customStyle: N };
    })(t.position, t.offset, t.toastBackgroundColor);
    n.value = x.value;
  }), xe(() => {
    J();
  }), { style: n, transitionType: u, startTimer: J, progress: w, onTouchStart: (x) => {
    i(x);
  }, onMouseLeave: () => {
    l("mousemove"), J();
  }, onMouseDown: (x) => {
    i(x);
  }, swipeStyle: a, isSlotPassed: H, isDescriptionHtml: Q, onMouseEnter: () => {
    t.timeout > 0 && o.value > 425 && b();
  } };
} });
const qr = { class: "mosha__toast__content-wrapper" }, Kr = { class: "mosha__toast__content" }, Wr = { class: "mosha__toast__content__text" }, Yr = { key: 1, class: "mosha__toast__content__description" }, Xr = { key: 0, class: "mosha__toast__slot-wrapper" };
Oe.render = function(t, e, n, o, r, i) {
  const a = Gn("MIcon");
  return p(), m(Ue, { name: t.transitionType, type: "animation" }, { default: zt(() => [t.visible ? (p(), m("div", { key: 0, class: ["mosha__toast", t.toastBackgroundColor ? null : t.type], style: [t.style, t.swipeStyle], onMouseenter: e[2] || (e[2] = (...l) => t.onMouseEnter && t.onMouseEnter(...l)), onMouseleave: e[3] || (e[3] = (...l) => t.onMouseLeave && t.onMouseLeave(...l)), onTouchstartPassive: e[4] || (e[4] = (...l) => t.onTouchStart && t.onTouchStart(...l)), onMousedown: e[5] || (e[5] = (...l) => t.onMouseDown && t.onMouseDown(...l)) }, [h("div", qr, [t.showIcon ? (p(), m(a, { key: 0, type: t.type }, null, 8, ["type"])) : k("", !0), h("div", Kr, [h("div", Wr, ct(t.text), 1), t.description.length > 0 && t.isDescriptionHtml ? (p(), m("div", { key: 0, class: "mosha__toast__content__description", innerHTML: t.description }, null, 8, ["innerHTML"])) : k("", !0), t.description.length > 0 && !t.isDescriptionHtml ? (p(), m("div", Yr, ct(t.description), 1)) : k("", !0)])]), t.isSlotPassed ? (p(), m("div", Xr, [Ct(t.$slots, "default")])) : k("", !0), t.showCloseButton ? (p(), m("div", { key: 1, class: "mosha__toast__close-icon", onClick: e[1] || (e[1] = (...l) => t.onCloseHandler && t.onCloseHandler(...l)) })) : k("", !0), t.hideProgressBar ? k("", !0) : (p(), m("div", { key: 2, class: "mosha__toast__progress", style: { width: `${t.progress}%` } }, null, 4))], 38)) : k("", !0)]), _: 3 }, 8, ["name"]);
};
const Ie = { "top-left": [], "top-right": [], "bottom-left": [], "bottom-right": [], "top-center": [], "bottom-center": [] };
let Gr = 0;
const Ma = (t, e) => {
  const n = Gr++, o = e ? Qr(e) : ue;
  if (t.__v_isVNode) return Re(n, ne.VNODE, o, t), { close: () => ie(n, o.position) };
  if (t.hasOwnProperty("render")) return Re(n, ne.COMPONENT, o, t), { close: () => ie(n, o.position) };
  const r = Jr(t);
  return Re(n, ne.TITLE_DESCRIPTION, o, r), { close: () => ie(n, o.position) };
}, Re = (t, e, n, o) => {
  setTimeout(() => {
    const r = ei(n, Ie, 12), i = document.createElement("div");
    let a;
    document.body.appendChild(i), a = e === ne.VNODE ? h(Oe, He(n, t, r, ie), () => [o]) : e === ne.TITLE_DESCRIPTION ? h(Oe, He(n, t, r, ie, o)) : h(Oe, He(n, t, r, ie), () => [h(o)]), It(a, i), Ie[n.position].push({ toastVNode: a, container: i }), a.component && (a.component.props.visible = !0);
  }, 1);
}, He = (t, e, n, o, r) => Qe(Z(Z({}, t), r), { id: e, offset: n, visible: !1, onCloseHandler: () => {
  o(e, t.position ? t.position : "top-right");
} }), Qr = (t) => {
  const e = Qe(Z({}, t), { type: t.type || ue.type, timeout: t.timeout || ue.timeout, showCloseButton: t.showCloseButton, position: t.position || ue.position, showIcon: t.showIcon, swipeClose: t.swipeClose, transition: t.transition || ue.transition });
  return e.hideProgressBar = e.timeout !== void 0 && e.timeout <= 0, t.hideProgressBar !== void 0 && (e.hideProgressBar = t.hideProgressBar), e;
}, Jr = (t) => ({ text: typeof t == "string" ? t : t.title, description: typeof t == "string" ? void 0 : t.description }), ei = (t, e, n) => {
  let o = n;
  if (!t.position) throw new Error("no position");
  return e[t.position].forEach(({ toastVNode: r }) => {
    const i = r.el.offsetHeight + n;
    o += i || 0;
  }), o;
}, ie = (t, e) => {
  const n = Ie[e], o = n.findIndex(({ toastVNode: l }) => l.props && t === l.props.id);
  if (o === -1) return;
  const { container: r, toastVNode: i } = n[o];
  if (!i.el) return;
  const a = i.el.offsetHeight;
  Ie[e].splice(o, 1), ((l, u, f, _) => {
    for (let E = l; E < u.length; E++) {
      const { toastVNode: A } = u[E];
      if (!A.el) return;
      const b = f.split("-")[0] || "top", w = parseInt(A.el.style[b], 10) - _ - 12;
      if (!A.component) return;
      A.component.props.offset = w;
    }
  })(o, n, e, a), i.component && (i.component.props.visible = !1, i.component.props.onClose && i.component.props.onClose(), setTimeout(() => {
    It(null, r), document.body.removeChild(r);
  }, 1e3));
}, Fe = {
  vsAcceptTerms: _o,
  vsBadge: wo,
  vsButton: bo,
  vsCard: go,
  vsCodeInput: vn,
  vsForm: yo,
  vsIcon: ho,
  vsInput: Rn,
  vsLogin: mn,
  vsMap: po,
  vsModal: mo,
  vsPreloader: vo,
  vsSelectSearcher: co,
  vsSidebar: pn,
  vsToolbar: fo,
  vsTable: hn,
  vsMessage: uo,
  vsInbox: yn,
  vsBilling: gn,
  vsTelInput: so,
  vsUpload: lo,
  vsSwitch: ao,
  vsAvatar: Vn,
  vsCalendar: io,
  vsIndicator: wn,
  vsPopover: ro,
  vsDisclosure: oo,
  vsSearchbar: no,
  vsBanner: _n,
  vsMenu: En,
  vsChat: Sn,
  vsChart: Tn,
  vsSlider: xn,
  vsProgressBar: An,
  vsItemArray: On,
  vsEditor: Cn,
  vsToast: to,
  vsListItem: Mn,
  vsSignaturePad: zn,
  vsInstancePicker: Ln,
  vsPaginator: eo,
  vsOmniSearch: In,
  vsAddressInput: Jn,
  vsPlaceInput: Bn,
  vsColorPicker: Pn,
  vsOtp: Qn,
  vsSwiper: Dn,
  vsTabs: kn,
  vsTagsInput: Nn,
  vsCalendarHeatmap: $n,
  vsRating: jn,
  vsTimePicker: bn
};
function ti(t) {
  for (const e in Fe)
    t.component(Fe[e].name, Fe[e]);
}
const za = { install: ti };
export {
  Oa as $vfm,
  Ma as createToast,
  za as default,
  Aa as initConfig,
  Ba as resolveImageSrc,
  Pa as setImageUrlResolver,
  Tr as vfmPlugin,
  _o as vsAcceptTerms,
  Jn as vsAddressInput,
  Vn as vsAvatar,
  wo as vsBadge,
  _n as vsBanner,
  gn as vsBilling,
  bo as vsButton,
  io as vsCalendar,
  $n as vsCalendarHeatmap,
  go as vsCard,
  Tn as vsChart,
  Sn as vsChat,
  vn as vsCodeInput,
  Pn as vsColorPicker,
  oo as vsDisclosure,
  Cn as vsEditor,
  yo as vsForm,
  ho as vsIcon,
  yn as vsInbox,
  wn as vsIndicator,
  Rn as vsInput,
  Ln as vsInstancePicker,
  On as vsItemArray,
  Mn as vsListItem,
  mn as vsLogin,
  po as vsMap,
  En as vsMenu,
  uo as vsMessage,
  mo as vsModal,
  In as vsOmniSearch,
  Qn as vsOtp,
  eo as vsPaginator,
  Bn as vsPlaceInput,
  ro as vsPopover,
  vo as vsPreloader,
  An as vsProgressBar,
  jn as vsRating,
  no as vsSearchbar,
  co as vsSelectSearcher,
  pn as vsSidebar,
  zn as vsSignaturePad,
  xn as vsSlider,
  Dn as vsSwiper,
  ao as vsSwitch,
  hn as vsTable,
  kn as vsTabs,
  Nn as vsTagsInput,
  so as vsTelInput,
  bn as vsTimePicker,
  to as vsToast,
  fo as vsToolbar,
  lo as vsUpload,
  Ca as withProps
};
//# sourceMappingURL=index.mjs.map
